import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { FormOperacionContraparte, schemaFormOperacionContraparte } from "./types/types"
import { zodResolver } from "@hookform/resolvers/zod"
import { HttpContraparte } from "./api/httpContraparte"
import { OperacionContraparteFields } from "./types/fields"
import toast from "react-hot-toast"
import { Box, Grid } from "@mui/material"
import { SeccionContraparteDatosOperacion } from "./components"
import { z } from "src/lib"
import { useCallback, useContext, useEffect, useState } from "react"
import { SeccionContrapartesCuentasNuevo } from "./components/SeccionContrapartesDetalleNuevo"
import { useLoader } from "src/hooks/useLoader"
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema"
import navigation from "src/navigation/vertical"
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion"


export const CuentaProvisionalFields = {
  IdProvisional: 'idProvisional',
  NroCuenta: 'nroCuenta',
  RazonSocial: 'razonSocial',
  CodMoneda: 'codMoneda',
  ImporteConcertacion: 'importe_Concertacion',
  ImporteDPV: 'importe_DPV',
  ImporteFOP: 'importe_FOP',
  BitEnvio: 'bitEnvio'
} as const

export const cuentaProvisional = z
  .object({
    [CuentaProvisionalFields.IdProvisional]: z.string(),
    [CuentaProvisionalFields.NroCuenta]: z.string(),
    [CuentaProvisionalFields.RazonSocial]: z.string(),
    [CuentaProvisionalFields.CodMoneda]: z.number(),
    [CuentaProvisionalFields.ImporteConcertacion]: z.number(),
    [CuentaProvisionalFields.ImporteDPV]: z.number(),
    [CuentaProvisionalFields.ImporteFOP]: z.number(),
  })

export type CuentaProvisional = z.infer<typeof cuentaProvisional>


type NuevoSistemaContraparteProps = {
  codSistemaPrincipal: number
}

export const NuevoSistemaContraparte = (props: NuevoSistemaContraparteProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const [cuentasProvisionales, setCuentasProvisionales] = useState<CuentaProvisional[]>([])

  const formMethods = useForm<FormOperacionContraparte>({
    resolver: zodResolver(schemaFormOperacionContraparte),
    defaultValues: {
      [OperacionContraparteFields.FechaAprobacion]: new Date()
    }
  })

  const alCrearOperacionContraparte = useCallback((data: FormOperacionContraparte, selected: number) => {
    if (!cuentasProvisionales.length) {
      toast.error('Debe cargar por lo menos una cuenta para enviar la operación.');
      
      return;
    }

    const payload = {
      ...data,
      [OperacionContraparteFields.Cuentas]: cuentasProvisionales,
      [OperacionContraparteFields.BitEnvio]: selected !== 1,
      [OperacionContraparteFields.CodPais]: props.codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpContraparte.post,
      successMessage: 'Guardado correctamente.',
      errorMessage: 'Error al guardar.'
    });
  }, [cuentasProvisionales, props.codSistemaPrincipal, submitOperacion]);

  const { setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => alCrearOperacionContraparte(data, 2))
    setSendPromise(onSend)
  }, [formMethods, alCrearOperacionContraparte])

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionContraparteDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={props.codSistemaPrincipal}
            codSistema={codSistema}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionContrapartesCuentasNuevo
            idPais={props.codSistemaPrincipal}
            cuentasProvisionales={cuentasProvisionales}
            setCuentasProvisionales={setCuentasProvisionales}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
